import React from 'react';


import { STATUS_URL } from '../../constants/apiUrls/apiUrls';
import callApi from '../../utils/callApi';
import couch from '../../assets/eila-on-the-couch2.jpg';

import PaymentContent from './CheckoutComponents/PaymentContent';


const MAX_TIME_IN_SECS_TO_CHECK_FOR_SUBSCRIPTION_INTERVAL = 15000;


class SuccessMessage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      processing: true,
      subNotActive: false,
    };
  }

  componentDidMount() {
    const { user } = this.props;
    if (user && user.authenticated) {
      const startTime = new Date().getTime();
      const interval = setInterval(() => {
        if (new Date().getTime() - startTime > MAX_TIME_IN_SECS_TO_CHECK_FOR_SUBSCRIPTION_INTERVAL) {
          clearInterval(interval);
          this.setState({
            subNotActive: true,
            processing: false,
          });

          return;
        }
        callApi(STATUS_URL, 'get', {}, {}, {}, true, true).
          then((res) => {
            if (res.data.user && res.data.user.activeSubscription) {
              this.setState({ processing: false }, () => clearInterval(interval));
            }
          }).
          catch((err) => console.error(err));
      }, 2000);
    } else {
      this.setState({ processing: false });
    }
  }


  render() {
    const { checkoutImage, anchorFirstName, loading, productType, isRenewal } = this.props;
    const { processing, subNotActive } = this.state;
    const anchorImage = checkoutImage ? checkoutImage : couch;

    return (
      <div className="content">
        <div className="container">
          <div className="card">
            <div className="checkout-container">
              <PaymentContent
                anchorFirstName={anchorFirstName}
                anchorImage={anchorImage}
                isRenewal={isRenewal}
                loading={loading}
                processing={processing}
                productType={productType}
                subNotActive={subNotActive}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SuccessMessage;

